import { jwtDecode } from "jwt-decode";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as api from "../../api/index";
import { IoMdArrowBack, IoMdRefresh } from "react-icons/io";
import { FaMapMarkerAlt, FaStore } from "react-icons/fa";
import productData from "../Outerpage/productlist";

// ✅ Lagos LGAs
const lagosLGAs = [
  "Agege", "Ajeromi-Ifelodun", "Alimosho", "Amuwo-Odofin", "Apapa", "Badagry",
  "Epe", "Eti-Osa", "Ibeju-Lekki", "Ifako-Ijaiye", "Ikeja", "Ikorodu", "Kosofe",
  "Lagos Island", "Lagos Mainland", "Mushin", "Ojo", "Oshodi-Isolo",
  "Shomolu", "Surulere"
];

export default function Connect() {
  const location = useLocation();
  const navigate = useNavigate();

  const selecteditem = location.state?.itemsShow || "";
  const subCategory = location.state?.subCategory || "";
  const category = location.state?.category || "";

  // ✅ Decode user token
  const token = localStorage.getItem("token");
  let userId = null;
  let typeofuser = null;
  if (token) {
    try {
      const decoded = jwtDecode(token);
      userId = decoded?._id || decoded?.id;
      typeofuser = decoded?.typeofuser;
    } catch {}
  }

  // ✅ States
  const [shop, setShop] = useState([]);
  const [loading, setLoading] = useState(true);
  const [profileSearch, setProfileSearch] = useState("");
const [searchingProfile, setSearchingProfile] = useState(false);
  const [lga, setLga] = useState(location.state?.lga || "All Lagos");
  const [error, setError] = useState("");
  const [relatedBrands, setRelatedBrands] = useState([]);
  const [activeBrand, setActiveBrand] = useState(selecteditem || "");


  // ✅ Fetch sellers with Caching logic
  // ✅ Fetch sellers with Caching logic


const fetchShop = async (forceRefresh = false) => {
  const navKey = location.key || "default";
  
  // 🎯 THE FIX: Use activeBrand (AI's fixed name) as priority
  const currentSearchTerm = activeBrand || selecteditem;

  const cacheKey = `shop_cache_${navKey}_${lga}_${currentSearchTerm}_${userId}`;
  const cachedData = sessionStorage.getItem(cacheKey);

  if (cachedData && !forceRefresh) {
    setShop(JSON.parse(cachedData));
    setLoading(false);
    return;
  }

  try {
    setLoading(true);
    const searchPayload = {
      lga,
      subCategory,
      itemsShow: currentSearchTerm, // 👈 Now it uses the corrected AI name
      viewerId: userId,
    };

    const res = await api.searchUser(searchPayload);

    if (res.data.success) {
      // ✅ res.data.sellers now automatically excludes anyone you've blocked
      const sellers = res.data.sellers.filter(biz => biz);
      setShop(sellers);
      sessionStorage.setItem(cacheKey, JSON.stringify(sellers));
      setError("");
    } else {
      setShop([]);
      setError("No sellers found");
    }
  } catch (err) {
    setShop([]);
    setError("Failed to load sellers.");
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    if (!selecteditem && !subCategory && !category) {
      setRelatedBrands([]);
      return;
    }

    let foundBrands = [];
    const selected = selecteditem?.toLowerCase() || "";
    const subCat = subCategory?.toLowerCase() || "";

    const matchedBlock = productData.find(
      (block) =>
        block.subcategory?.toLowerCase() === subCat ||
        block.subcategory?.toLowerCase().includes(selected) ||
        block.products.some((p) => p.name.toLowerCase() === selected)
    );

    if (matchedBlock) {
      foundBrands = matchedBlock.products.map((p) => p.name);
    }
    setRelatedBrands(foundBrands);
  }, [selecteditem, subCategory, category]);


const handleProfileSearch = async () => {
  const value = profileSearch.trim();

  if (!value) return;

  try {
    setSearchingProfile(true);
    setError("");

    const res = await api.searchUserByProfile(value, userId);

    if (res.data?.success && res.data?.user?._id) {
      navigate(`/shop/${res.data.user._id}`);
    } else {
      setError("No seller found with that profile.");
    }
  } catch (err) {
    console.error("PROFILE SEARCH ERROR:", err);
    setError(err.response?.data?.message || "Seller not found.");
  } finally {
    setSearchingProfile(false);
  }
};

useEffect(() => {
  if (location.state?.isAiSearch && location.state?.aiResults) {
    // If we just came from AI search, use those results immediately
    setShop(location.state.aiResults);
    
    // Set the "activeBrand" so the UI shows the clean AI name
    if (location.state.itemsShow) {
      setActiveBrand(location.state.itemsShow);
    }
    setLoading(false);
  } else {
    // If the user changes the LGA dropdown, this runs
    fetchShop();
  }
  // Listen for lga or activeBrand changes
}, [lga, activeBrand, selecteditem]);


  return (
    <div className="flex flex-col min-h-screen bg-gray-50 pb-20">
      {/* 🔝 Navbar */}
      <div className="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b px-4 py-4 flex justify-between items-center shadow-sm">
        <button
          onClick={() => navigate(-1)}
          className="p-2 hover:bg-gray-100 rounded-full transition flex items-center gap-1 text-gray-700"
        >
          <IoMdArrowBack size={24} />
          <span className="hidden sm:inline font-medium">Back</span>
        </button>

        <button
          onClick={() => fetchShop(true)}
          className="flex items-center gap-2 bg-teal-600 text-white px-4 py-2 rounded-xl hover:bg-teal-700 transition text-sm font-semibold"
        >
          <IoMdRefresh size={18} className={loading ? "animate-spin" : ""} />
          Refresh
        </button>
      </div>

{/* Profile Link/ID Search Bar with "How?" */}

<div className="px-4 pt-3">
  <div className="max-w-6xl mx-auto">
    <button
      onClick={() => navigate("/how-to-search-profile")}
      className="text-xs text-teal-600 font-semibold hover:underline"
    >
      How does this work?
    </button>

    <div className="flex gap-2 mt-2">
      <input
        type="text"
        value={profileSearch}
        onChange={(e) => setProfileSearch(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") handleProfileSearch();
        }}
        placeholder="Paste seller profile ID"
        className="flex-1 bg-white border border-gray-200 px-4 py-3 rounded-2xl outline-none focus:ring-2 focus:ring-teal-500 text-sm"
      />

      <button
        onClick={handleProfileSearch}
        disabled={searchingProfile || !profileSearch.trim()}
        className="bg-teal-600 text-white px-5 rounded-2xl font-bold text-sm disabled:opacity-50"
      >
        {searchingProfile ? "..." : "Search"}
      </button>
    </div>
  </div>
</div>

      <div className="max-w-6xl mx-auto w-full p-4 sm:p-6 space-y-6">
        {/* 🏷 Header & Filter Section */}
        <div className="bg-white rounded-3xl p-5 shadow-sm border border-gray-100">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <h1 className="text-2xl font-black text-gray-900">
                Sellers in {lga === "All Lagos" ? "Lagos" : lga}
              </h1>
              {selecteditem && (
                <p className="text-gray-500 text-sm mt-1 italic">
                  Filtering for: <span className="text-orange-600 font-bold">{selecteditem}</span>
                </p>
              )}
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-xs font-bold text-gray-400 uppercase tracking-widest ml-1">Location Filter</label>
              <select
                value={lga}
                onChange={(e) => setLga(e.target.value)}
                className="appearance-none bg-gray-50 border border-gray-200 px-4 py-2.5 rounded-2xl text-sm font-semibold focus:ring-2 focus:ring-teal-500 outline-none cursor-pointer"
              >
                <option value="All Lagos">📍 All Lagos</option>
                {lagosLGAs.map((item, idx) => (
                  <option key={idx} value={item}>{item}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Related brands tags */}
          {relatedBrands.length > 0 && (
            <div className="flex items-center gap-2 mt-6 overflow-x-auto pb-2 no-scrollbar">
              <span className="text-xs font-bold text-gray-400 whitespace-nowrap uppercase tracking-tighter">Related:</span>
              {relatedBrands.map((brand, i) => (
                <button
                  key={i}
                  onClick={() => {
                    setActiveBrand(brand);
                    navigate("/connect", { state: { itemsShow: brand, subCategory, category } });
                  }}
                  className={`px-4 py-1.5 rounded-full text-xs font-bold whitespace-nowrap transition-all border
                    ${activeBrand === brand
                      ? "bg-teal-600 text-white border-teal-600 shadow-lg shadow-teal-100"
                      : "bg-white text-gray-600 border-gray-200 hover:border-teal-400 hover:text-teal-600"
                    }`}
                >
                  {brand}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Loading state */}
        {loading && (
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
            {[1, 2, 3].map((n) => (
              <div key={n} className="h-64 bg-gray-200 animate-pulse rounded-3xl" />
            ))}
          </div>
        )}

        {/* 🏪 Sellers Grid: 2 columns on Mobile/iPad, 3 on Laptop */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6">
          {!loading && !error && shop.length > 0 &&
            shop.map((biz) => (
              <div
                key={biz._id}
                className="group bg-white rounded-[2rem] border border-gray-100 hover:border-teal-500 transition-all duration-300 flex flex-col overflow-hidden shadow-sm hover:shadow-xl"
              >
                <div className="relative h-32 sm:h-48 overflow-hidden">
                  <img 
                    src={biz?.profileImage || "/placeholder.jpg"} 
                    alt={biz?.Name} 
                    className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
                  />
                  <div className="absolute top-2 right-2 bg-white/90 backdrop-blur px-2 py-1 rounded-lg text-[10px] font-bold flex items-center gap-1 shadow-sm">
                    <FaMapMarkerAlt className="text-teal-600" />
                    {biz?.lga || "Lagos"}
                  </div>
                </div>

                <div className="p-3 sm:p-5 flex flex-col flex-1">
                  <h2 className="font-black text-gray-900 text-sm sm:text-lg truncate group-hover:text-teal-600 transition">
                    {biz?.Name}
                  </h2>
                  
                  <p className="text-gray-500 text-[11px] sm:text-sm mt-1 leading-snug line-clamp-2 min-h-[32px] sm:min-h-[40px]">
                    {biz?.bio || "Verified Seller in Lagos"}
                  </p>

                  {/* Services Tags */}
                  {biz?.fields?.length > 0 && (
                    <div className="mt-3 flex flex-wrap gap-1">
                      {biz?.fields.slice(0, 2).map((field, index) => (
                        <span key={index} className="px-2 py-0.5 bg-orange-50 text-orange-600 rounded-md text-[9px] sm:text-[10px] font-black uppercase tracking-tighter">
                          {field}
                        </span>
                      ))}
                      {biz.fields.length > 2 && <span className="text-[10px] text-gray-400">+{biz.fields.length - 2}</span>}
                    </div>
                  )}

                  <div className="mt-4 pt-4 border-t border-gray-50">
                    <button
                      onClick={() => navigate(`/shop/${biz._id}`)}
                      className="w-full flex items-center justify-center gap-2 bg-gray-900 text-white py-2.5 sm:py-3 rounded-2xl hover:bg-teal-600 transition shadow-lg shadow-gray-200 text-[11px] sm:text-sm font-bold"
                    >
                      <FaStore />
                      View Store
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </div>

        {/* Empty State */}
        {!loading && shop.length === 0 && (
          <div className="text-center py-20 bg-white rounded-[3rem] border-2 border-dashed border-gray-100">
            <div className="text-5xl mb-4">🔍</div>
            <h3 className="text-xl font-bold text-gray-900">No sellers found</h3>
            <p className="text-gray-500 max-w-xs mx-auto mt-2">
              We couldn't find any sellers matching your current filters in {lga}.
            </p>
            <button 
              onClick={() => {setLga("All Lagos"); fetchShop(true);}}
              className="mt-6 text-teal-600 font-bold underline"
            >
              Clear filters
            </button>
          </div>
        )}
      </div>
    </div>
  );
}